<template>
  <v-card-text>
    <v-layout row wrap>
      <v-flex xs12 md6 v-if="team">
        <v-btn
          :to="{ name: 'completionMonth', query: { teamId: team.id } }"
          @click.native="$emit('navigated')"
          small
        >
          <v-icon>date_range</v-icon>Completion month
        </v-btn>
        <v-btn
          :to="{
            name: 'matterList',
            query: { teamid: team.id, departmentid: 1 }
          }"
          @click.native="$emit('navigated')"
          small
          >Matter list</v-btn
        >
        <v-btn
          :to="{ name: 'os1', query: { teamid: team.id } }"
          @click.native="$emit('navigated')"
          small
          >OS1</v-btn
        >
        <v-btn
          :to="{ name: 'undertakings', query: { teamid: team.id } }"
          @click.native="$emit('navigated')"
          small
          >Undertakings</v-btn
        >
      </v-flex>
      <v-flex xs12 md6>
        <v-select
          label="Team"
          v-model="teamid"
          :items="teams"
          item-value="id"
          item-text="name"
          @change="updateTeam"
          outline
        />
      </v-flex>
    </v-layout>
    <div v-if="summary" class="convTool">
      <SimpleList :simpleList="summary.legal" @navigated="$emit('navigated')" />
      <SimpleList
        :simpleList="summary.postcompletion"
        @navigated="$emit('navigated')"
      />
      <SimpleList :simpleList="summary.notes" @navigated="$emit('navigated')" />
      <SimpleList
        :simpleList="summary.messages"
        @navigated="$emit('navigated')"
      />
      <SimpleList
        :simpleList="summary.undertakings"
        @navigated="$emit('navigated')"
      />
      <SimpleList :simpleList="summary.os1" @navigated="$emit('navigated')" />
      <DateList
        :dateList="summary.completions"
        @navigated="$emit('navigated')"
      />
      <div style="clear: both; text-align: center">...</div>
    </div>
  </v-card-text>
</template>

<script>
import SUMMARY from "@/graphql/directory/Summary";
import TEAMS from "@/graphql/directory/Teams";
import SimpleList from "./summary/SimpleList";
import DateList from "./summary/DateList";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Summary",
  components: {
    SimpleList,
    DateList
  },
  props: ["lastUpdated"],
  apollo: {
    summary: {
      query: SUMMARY,
      variables() {
        return {
          lastUpdated: this.lastUpdated
        };
      },
      fetchPolicy: "cache-and-network"
    },
    teams: {
      query: TEAMS,
      variables: { archived: false },
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      team: null,
      teamid: null
    };
  },
  methods: {
    async fetchTeam() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/current/team`
      );
      // console.log(response.data);
      this.team = response.data;
    },
    async updateTeam() {
      await nbmlaw.put(
        `/cors/admin/directory/entities/current/staff/team`,
        null,
        { params: { teamid: this.teamid } }
      );
      // console.log(response.data);
      this.$apollo.queries.summary.refetch();
      this.update();
    },
    updated() {
      this.$emit("updated");
    },
    update() {
      this.fetchTeam();
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        this.update();
      }
    },
    team: {
      handler() {
        this.teamid = this.team ? this.team.id : null;
      }
    }
  }
};
</script>


<style>
.simpleList {
  float: left;
  text-align: center;
  padding: 3px;
  margin-right: 3px;
}
</style>
